import { useEffect, useState } from "react";

const PHONE_DISPLAY = "+49 2642 948 30 70";
const PHONE_TEL = "tel:+4926429483070";

export default function CallDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
      setCopied(false);
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  const handleCopy = async () => {
    const text = PHONE_DISPLAY;
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.focus();
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-[90] flex items-center justify-center px-4"
      role="dialog"
      aria-modal="true"
      aria-label="Anruf-Dialog"
    >
      <div
        className="absolute inset-0 bg-ink/60 backdrop-blur-sm"
        onClick={onClose}
      />

      <div className="relative w-full max-w-md rounded-2xl bg-bg border border-line p-8 md:p-10 shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full border border-ink/15 hover:bg-ink hover:text-bg text-ink transition-all cursor-pointer"
          aria-label="Schließen"
        >
          <i className="ri-close-line text-lg"></i>
        </button>

        <div className="flex items-center justify-center w-14 h-14 rounded-full bg-sage/10 text-sage mb-6">
          <i className="ri-phone-line text-2xl"></i>
        </div>

        <h3 className="font-display text-2xl md:text-3xl font-light text-ink leading-tight mb-3">
          Wir freuen uns auf Ihren Anruf!
        </h3>

        <p className="font-display text-xl md:text-2xl text-ink tabular-nums mb-8">
          {PHONE_DISPLAY}
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <a
            href={PHONE_TEL}
            className="flex-1 px-6 py-3 rounded-[var(--btn-radius)] bg-sage text-bg text-sm font-medium hover:bg-ink transition-colors cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            <i className="ri-phone-line"></i>
            Anrufen
          </a>

          <button
            onClick={handleCopy}
            className="flex-1 px-6 py-3 rounded-[var(--btn-radius)] border border-ink/20 text-ink text-sm font-medium hover:bg-ink hover:text-bg transition-all cursor-pointer whitespace-nowrap inline-flex items-center justify-center gap-2"
          >
            <i className={copied ? "ri-check-line" : "ri-file-copy-line"}></i>
            {copied ? "Kopiert!" : "Nummer kopieren"}
          </button>
        </div>
      </div>
    </div>
  );
}